import BaseForgeCustomizer from '../../base-forge';
import { isAnetUser } from '../../../utils/user-utils';
import ProxyFooter from '../../../components/common/ProxyFooter';
import { getLocalizedString } from '../../../utils/i18n-utils';

export default abstract class FactorEnrollCustomizerBase extends BaseForgeCustomizer {
  abstract forgifyFactors(): void;

  displayFooterText = isAnetUser();
  headerDescription = getLocalizedString('enroll.choices.description.generic');

  protected forgifyController() {
    super.forgifyController();
    this.forgifyFactors();
  }

  async shouldCustomize() {
    this.adjustHeaders();
    return [ 'enroll-choices' ].includes(this.context.controller);
  }

  async customize(): Promise<void> {
    await super.customize();
  }

  protected getFooter({ footerLink }: { footerLink: JQuery }) {
    return (
      <ProxyFooter
        text={this.hasUserSetupAnyFactor() ? '' : this.footerText}
        footerLinks={footerLink}
        alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
      />
    );
  }

  protected hasUserSetupAnyFactor() {
    return jQueryCourage('.button-primary').length  > 0;
  }


  private adjustHeaders() {
    if (isAnetUser()) {
      if (this.hasUserSetupAnyFactor()) {
        this.headerText = getLocalizedString('enroll.choices.optional.title');
        this.headerDescription = getLocalizedString('enroll.choices.optional.description');
      }
    }
  }
}

